import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

 
const GOOGLE_MAPS_API_KEY = 'AIzaSyDF5qhTwPgPjzQmG6EE8EZa8LeQOoFZmUY';
 
export type Maps = typeof google.maps;

 
@Injectable()
export class GoogleService {

    /**
     *
     * @param {HttpClient} _http
     */
  constructor(private _http: HttpClient) {}


  getOptions(searchValue){
    return new Promise((resolve, reject) => {            
        this._http.post(`${environment.apiUrl}/getGoogleAddress`, {"search": searchValue}).subscribe((response: any) => {
        resolve(response);        
        }, reject);       
      });
  
  }  
 
}